// Require the polyfill before requiring any other modules.
// require('intersection-observer');

/**
 * Babel includes a polyfill that includes a custom regenerator runtime and core-js.
 * This will emulate a full ES2015+ environment and is intended to be used in an
 * application rather than a library/tool.
 */

// require('babel-polyfill');

/**
 * Modernizr tests touchevents.
 */

require('browsernizr/test/touchevents');
require('browsernizr/lib/addTest');
require('browsernizr/test/elem/picture');
window.Modernizr = require('browsernizr');

/**
 * Axios HTTP library for making requests.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.qs = require('qs');
window.axios.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded';

// CSRF service - auto-attaches token to mutating requests
import './services/csrf';

/**
 * Zenscroll is a vanilla JavaScript library that enables animated
 * vertical scrolling to an element or position within your
 * document or within a scrollable element (DIV, etc.).
 */

window.zenscroll = require('zenscroll');
